import React,{useState,useEffect} from 'react';
import GitHub from '../../svg/GitHub';
import './navbar.css';
import {Link, NavLink, useLocation} from 'react-router-dom';

function Navbar() {

    const [open, setopen] = useState(false);
    const [Nav, setNav] = useState(false);
    const [path,setpath] = useState("");
    const location = useLocation();
    const checkPath = path === '/portfolio';

    const linkList = [
        {
            page:'Home',
            link:'/'
        },
        {
            page:'About',
            link:'/'
        },
        {
            page:'Portfolio',
            link:'/'
        },
        {
            page:'Contact',
            link:'/'
        },
    ]

    const hrefList = [
        {
            page:'Home',
            link:'#home'
        },
        {
            page:'About',
            link:'#about'
        },
        {
            page:'Portfolio',
            link:'#portfolio'
        },
        {
            page:'Contact',
            link:'#contact'
        },
    ]


    useEffect(() => {
        setpath(location.pathname);
    }, [location]);


        const changeBackground = () =>{
                
            if(window.scrollY >= 100){
                setNav(true);
            }
            else{
                setNav(false);
            }
        }

        window.addEventListener('scroll', changeBackground);


        const handleHamburger = () =>{
            setopen(!open);
            if(open){
                document.querySelector('.body').classList.remove('active');
            }
            else{
                document.querySelector('.body').classList.add('active');
            }
        }

        const handleNavlinkClick =() =>{
            setopen(false);
            document.querySelector('.body').classList.remove('active');
        }   

    return (
            <div className={Nav ? "nav active" : "nav" }>
                <div className="container">
                    <div className="logo-block">
                        <NavLink to="/">
                            <h1 className="logo">Ashish</h1>
                         </NavLink>
                    </div>
            
                    <div className="side-menu">
                        <ul className={ open ? "nav-list active" : "nav-list"}>
                            
                            {checkPath ? (
                                linkList.map(({page,link}, index) =>(
                                    <Link to={link} key={index} ><li className="nav-link" onClick={handleNavlinkClick} >{page}</li></Link>
                                ))
                            ) : (
                                hrefList.map(({page,link}, index) =>(
                                    <a href={link} key={index}>
                                       <li className="nav-link" onClick={handleNavlinkClick} >{page}</li>
                                    </a>
                                ))
                            )}

                            <a href="https://github.com/Ashish8689" target="_blank" rel="noreferrer"><li className="nav-link"><GitHub className="github" /></li></a>  
                        </ul>
                    </div>  
                    
                    <div className="hamburger" onClick={handleHamburger} >
                        <span className={open ? "span span1 active" : "span span1"}></span>
                        <span className={open ? "span span2 active" : "span span2"}></span>
                    </div>

                </div>

                <div className="box-bar"></div>
                <div className="circle-round"></div>
            </div>
    )
}

export default Navbar
